// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"42145387","879":"56a3611b"}[chunkId] + ".chunk.js";
};